// PRIME REACT CSS — first
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import Login from "./components/Login";
import Register from "./components/Register";
import CreateQuery from "./components/CreateQuery";
import ClientDashboard from "./components/ClientDashboard";
import SupportDashboard from "./components/SupportDashboard";
import Layout from "./components/sidebar/Layout";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import GetAllUsers from "./components/GetAllUsers";

import ProtectedRoutes from "./components/login/ProtectedRotes";
import CreateDep from "./components/CreateDep";
import CreateBranch from "./components/CreateBranch";







function App() {
  return (
    <div className="App">
      <BrowserRouter>
      
        <Routes>

          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />


          {/* Protected Routes */}
          <Route element={<ProtectedRoutes> <Layout /> </ProtectedRoutes>}>

              <Route path="/clientquery" element={<CreateQuery userId={localStorage.getItem("user_id")} />} />
              <Route path="/clientdashboard" element={<ClientDashboard />} />
              <Route path="/supportdashboard" element={<SupportDashboard />} />
              <Route path="/adminuser" element={<GetAllUsers />} />
              <Route path="/add_dep" element={<CreateDep />} />
              <Route path="/add_branch" element={<CreateBranch />} />

          </Route>

        </Routes>

      </BrowserRouter>
    </div>
  );
}


export default App;
